import React, { useEffect, useRef, useState } from "react";
import Notifications from "react-notifications-menu";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CustomNotificationCard = ({ data, markAsRead }) => {
  const [actionTaken, setActionTaken] = useState(false);

  if (!data) {
    return null;
  }

  const { message, image, notificationId, notifyType, priority, time, isRead } =
    data;

  // const handleImageClick = () => {
  //   toast.success("Action Taken");
  //   setActionTaken(!actionTaken);
  // };

  const handleCardClick = () => {
    markAsRead(notificationId);
  };

  return (
    <>
      <div
        class={`notification-card ${!isRead ? null : "notification-card-read"}`}
        key={notificationId}
        onClick={handleCardClick}
      >
        <div class="card-link">
          <div class="notification-content">
            <div class="notification-image">
              <img  src={image && image} alt="Person " />
            </div>
            <div class="notification-message">
              <div class="notification-text">{message}</div>
              <div className="notification-time">{time}</div>
            </div>
          </div>
        </div>

        {/* Additional filter options */}
        <div className="notification-options">
          <div
            className={`notification-options-badge notification-options-badge-type-${
              notifyType === "Health"
                ? "health"
                : notifyType === "Sustainability"
                ? "sustainability"
                : notifyType === "Security"
                ? "security"
                : notifyType === "Occupancy"
                ? "occupancy"
                : notifyType === "Other"? "other":""
            }
            }`}
          >
            {notifyType}
          </div>

          {priority === 1 ? (
            <img src="images/icons/Alert.gif" width={30} height={30} />
          ) : (
            <img src="images/icons/Calendar.png" width={25} height={25} />
          )}
        </div>
      </div>
    </>
  );
};

const Notification = () => {
  const [data, setData] = useState([]);
  const notificationRef = useRef(null);
  const [initialData, setInitialData] = useState([
  ])
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    setData([
      {
        notificationId: 1,
        image: "images/User Picture.png",
        message: "Warning: The temperature is high in main office",
        detailPage: "/",
        notifyType: "Health",
        priority: 1,
        time: "15 minutes ago",
        isRead: false,
      },
      {
        notificationId: 2,
        image: "images/User Picture.png",
        message: "Controlled: Energy save at unit 1833 main floor",
        detailPage: "/",
        notifyType: "Sustainability",
        priority: 2,
        time: "2 hours ago",
        isRead: false,
      },
      {
        notificationId: 3,
        image: "images/User Picture.png",
        message: "Controlled: Energy save at unit 24 second floor",
        detailPage: "/",
        notifyType: "Sustainability",
        priority: 1,
        time: "5 hours ago",
        isRead: false,
      },
      {
        notificationId: 4,
        image: "images/User Picture.png",
        message: "Controlled: The space has been clear for usage",
        detailPage: "/",
        notifyType: "Occupancy",
        priority: 2,
        time: "6 hours ago",
        isRead: false,
      },
      {
        notificationId: 5,
        image: "images/User Picture.png",
        message: "Controlled: The space has been clear for usage",
        detailPage: "/",
        notifyType: "Security",
        priority: 3,
        time: "7 hours ago",
        isRead: false,
      },
      {
        notificationId: 6,
        image: "images/User Picture.png",
        message: "Controlled: The space has been clear for usage",
        detailPage: "/",
        notifyType: "Health",
        priority: 2,
        time: "1 day ago",
        isRead: false,
      },   {
        notificationId: 7,
        image: "images/User Picture.png",
        message: "Software Update: Version 1.0.11 released🎉",
        detailPage: "/newfeature",
        notifyType: "Other",
        priority: 2,
        time: "1 day ago",
        isRead: false,
      },
      {
        notificationId: 8,
        image: "images/User Picture.png",
        message: "Hardware Update: Patch 10 release to Device 5 and 6🎉",
        detailPage: "/newfeature",
        notifyType: "Other",
        priority: 2,
        time: "1 day ago",
        isRead: false,
      },
    ]);

    setInitialData([
      {
        notificationId: 1,
        image: "images/User Picture.png",
        message: "Warning: The temperature is high in main office",
        detailPage: "/",
        notifyType: "Health",
        priority: 1,
        time: "15 minutes ago",
        isRead: false,
      },
      {
        notificationId: 2,
        image: "images/User Picture.png",
        message: "Controlled: Energy save at unit 18 main floor",
        detailPage: "/",
        notifyType: "Sustainability",
        priority: 2,
        time: "2 hours ago",
        isRead: false,
      },
      {
        notificationId: 3,
        image: "images/User Picture.png",
        message: "Controlled: Energy save at unit 24 second floor",
        detailPage: "/",
        notifyType: "Sustainability",
        priority: 1,
        time: "5 hours ago",
        isRead: false,
      },
      {
        notificationId: 4,
        image: "images/User Picture.png",
        message: "Controlled: The space has been clear for usage",
        detailPage: "/",
        notifyType: "Occupancy",
        priority: 2,
        time: "6 hours ago",
        isRead: false,
      },
      {
        notificationId: 5,
        image: "images/User Picture.png",
        message: "Controlled: The space has been clear for usage",
        detailPage: "/",
        notifyType: "Security",
        priority: 3,
        time: "7 hours ago",
        isRead: false,
      },
      {
        notificationId: 6,
        image: "images/User Picture.png",
        message: "Controlled: The space has been clear for usage",
        detailPage: "/",
        notifyType: "Health",
        priority: 2,
        time: "1 day ago",
        isRead: false,
      },
      {
        notificationId: 7,
        image: "images/User Picture.png",
        message: "Software Update: Version 1.0.11 released 🎉",
        detailPage: "/newfeature",
        notifyType: "Other",
        priority: 2,
        time: "1 day ago",
        isRead: false,
      },
      {
        notificationId: 8,
        image: "images/User Picture.png",
        message: "Hardware Update: Patch 10 release to Device 5 and 6 🎉",
        detailPage: "/newfeature",
        notifyType: "Other",
        priority: 2,
        time: "1 day ago",
        isRead: false,
      },
    ])

    // Add customize filter options to the Notification Component(predefined lib)
    const filterButtonContainer = document.createElement("div");
    filterButtonContainer.classList.add("notification-filter-container");

    const filterByTypeBtn = document.createElement("button");
    filterByTypeBtn.textContent = "By Type";
    filterByTypeBtn.addEventListener("click", () => {
      if (notificationRef.current.state.data) {
        const sortedData = [...notificationRef.current.state.data].sort(
          (a, b) => a.notifyType.localeCompare(b.notifyType)
        );
        setData(sortedData);
      }
    });

    const searchBox = document.createElement("input");
    searchBox.classList.add("search-box");
    searchBox.placeholder = "Search for notifications";
    searchBox.addEventListener("input", (e) => {
      console.log("Search...")
    });

    const filterButton = document.createElement("button");
    filterButton.textContent = "Filter";

    filterByTypeBtn.classList.add("filter-button");

    const filterByPriorityBtn = document.createElement("button");
    filterByPriorityBtn.textContent = "By Priority";
    filterByPriorityBtn.addEventListener("click", () => {
      if (notificationRef.current.state.data) {
        const sortedData = [...notificationRef.current.state.data].sort(
          (a, b) => a.priority - b.priority
        );
        setData(sortedData);
      }
    });

    filterByTypeBtn.classList.add("filter-button");
    filterByPriorityBtn.classList.add("filter-button");

    filterButtonContainer.appendChild(filterByTypeBtn);
    filterButtonContainer.appendChild(filterByPriorityBtn);
    filterButtonContainer.appendChild(searchBox);

    const headerElement = document.querySelector(".notification-header");
    headerElement.parentNode.insertBefore(
      filterButtonContainer,
      headerElement.nextSibling
    );

    // Clean up the filter button container when the component unmounts
    return () => {
      filterButtonContainer.parentNode.removeChild(filterButtonContainer);
    };
  }, []);

  useEffect(() => {
    if (data) {
      const updatedCount = data.filter((item) => !item.isRead).length;
      notificationRef.current.setState((prevState) => ({
        ...prevState,
        notificationCount: updatedCount,
      }));
    }
  }, [data]);

  const handleMarkAsRead = (notificationId) => {
    // Logic for marking the data as read
    setData((prevData) => {
      return prevData.map((item) => {
        if (item.notificationId === notificationId) {
          return { ...item, isRead: true };
        }
        return item;
      });
    });
  };

  return (
    <>
      <Notifications
        ref={notificationRef}
        height="500px"
        width="500px"
        data={data}
        header={{
          title: "Notification",
          option: {
            text: "Mark selected as read",
            onClick: () => console.log("Clicked"),
          },
        }}
        classNamePrefix="notification"
        icon="images/bell.png"
        notificationCard={CustomNotificationCard}
        markAsRead={handleMarkAsRead}
        viewAllBtn={{
          text:"View All",
          onClick: ()=>{console.log("View all btn")}
        }}
      />
      <ToastContainer theme="dark" />
    </>
  );
};

export default Notification;
